export const MEDIA_BUFFER_STATUSES = {
  INITIAL: 'INITIAL',
  BUFFERING: 'BUFFERING'
};